const isProd = import.meta.env.PROD

export function log(label: string, ...message: any[]) {
  // NOTE: in production, only log error messages
  if (isProd && label !== 'error') return;
  console.log(`[SONARIS] ${label.toUpperCase()}:`, ...message)
}
